import axios from 'axios';
import { useUser } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { AUTH_API_BASE_URL } from '../../config/api-config';
import { getToken } from '../../Compo/utilis/getToken';
import { runBeforeLogout } from '../lib/dealSession';
import { markSigningOut } from '../../Apicall/signOutState';

// Public header state comes from the existing authenticated application.
export function useAuth() {
  const { userId, displayName, emailAddress, refreshUserInfo } = useUser();
  const navigate = useNavigate();
  return {
    isAuthenticated: Boolean(userId),
    user: { fullName: displayName, email: emailAddress },
    logout: async () => {
      // Tell a connected deal counterpart (and refresh the deal's 60-minute
      // expiry) while the session is still valid — applies to manual sign-out
      // and to the idle timeout alike. See DealSessionManager.
      await runBeforeLogout();
      markSigningOut(getToken());
      // Invalidate the session server-side: TokenAuth/LogOut rotates the user's
      // security stamp, so AuthConfigurer's OnTokenValidated rejects this JWT on
      // its very next use instead of it remaining valid until it naturally
      // expires. Best-effort — never block local logout on it.
      try {
        const token = getToken();
        if (token) {
          await axios.post(
            `${AUTH_API_BASE_URL}/TokenAuth/LogOut`,
            {},
            { headers: { Authorization: `Bearer ${token}` }, timeout: 5000 }
          );
        }
      } catch (_) {
        /* server unreachable — the local token is cleared below regardless */
      }
      localStorage.removeItem('authToken');
      await refreshUserInfo();
      navigate('/Home');
    },
  };
}
